import { Theme } from '@mui/material';

const TextField = (theme: Theme) => {
  return {
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
      },
      styleOverrides: {
        root: {
          '.MuiFormLabel-colorSecondary.Mui-focused': {
            color: theme.palette.primary.main,
          },
        },
      },
    },
    MuiPickersTextField: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
  };
};

export default TextField;
